import { useRef, type RefObject } from "react";
import { Button } from "@/ui";
import { ToolIcon } from "./toolIcons";

/** 列表页工具栏的“清除筛选”：只有图标的按钮（带叉的漏斗），放在 Toolbar 的 actions 里，只在有条件时由调用方渲染（决策 D198，#541 推广到各列表页）。
 * 清除后按钮随即消失，焦点先交给 focus（缺省是工具栏里的第一个控件），键盘用户不会掉回页面开头。 */
export function ClearFilters({ onClear, focus }: { onClear: () => void; focus?: RefObject<HTMLElement> }) {
  const ref = useRef<HTMLButtonElement>(null);
  const clear = () => {
    const first = ref.current?.closest(".ax-toolbar")?.querySelector<HTMLElement>("input, button, [tabindex='0']");
    (focus?.current ?? first)?.focus();
    onClear();
  };
  return <Button ref={ref} size="sm" iconOnly aria-label="清除筛选" title="清除筛选" onClick={clear}><ToolIcon name="filter-x" /></Button>;
}
